export const GET_INTEGRATIONS = 'GET_INTEGRATIONS';
export const INIT_INTEGRATIONS = 'INIT_INTEGRATIONS';
export const DELETE_INTEGRATION = 'DELETE_INTEGRATION';
export const GET_RACE = 'GET_RACE';
